import { useState, useEffect } from 'react';

import { getEnvironmentFromUrl, useEnvironment } from '@cccom/config/env';

const LOGO_MAP: Record<string, string> = {
  dev: 'orise_logo.png',
  qa: 'orise_logo.png',
  demo: 'orise_logo.png',
  mnk: 'mnk_logo.svg',
  amgen: 'amgen_logo.svg',
  takeda: 'takeda_logo.svg',
};

export const useCompanyLogoSrc = (): { companyLogoSrc: string } => {
  const env = useEnvironment();
  const [companyLogoSrc, setCompanyLogoSrc] = useState<string>('');

  const baseUrl = `${env.STATIC_ASSETS_URL}/images/logos`;

  useEffect(() => {
    const environment = getEnvironmentFromUrl();
    setCompanyLogoSrc(
      `${baseUrl}/${LOGO_MAP[environment] || 'orise_logo.png'}`
    );
  }, [baseUrl]);

  return { companyLogoSrc };
};
